"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_BALANCE = exports.SIGN_TX = exports.CREATE_TX = exports.GET_TX_QUEUE = exports.GET_TX_HISTORY = exports.GET_SAFE_LIST = exports.GET_SAFE = void 0;
const client_1 = require("@apollo/client");
exports.GET_SAFE = (0, client_1.gql) `
  query Safe($chainId: String!, $safeAddress: String!) {
    safe(chainId: $chainId, safeAddress: $safeAddress) {
      address
      chainId
      owners {
        address
        publicKey
      }
      safeId
      threshold
    }
  }
`;
exports.GET_SAFE_LIST = (0, client_1.gql) `
  query getSafeList($ownerAddress: String!) {
    ownedSafes(ownerAddress: $ownerAddress) {
      address
      chainId
      owners {
        address
        publicKey
      }
      safeId
      threshold
    }
  }
`;
exports.GET_TX_HISTORY = (0, client_1.gql) `
  query transactionHistory($chainId: String!, $safeAddress: String!) {
    transactionHistory(chainId: $chainId, safeAddress: $safeAddress) {
      summary {
        createdAt
        multiSigExecutionInfo {
          orderCellBoc
          queryId
          expiredAt
          confirmationsRequired
          confirmationsSubmitted
          confirmations
          executor
        }
        status
        transactionInfo {
          ... on Transfer {
            transactionType
            sender
            recipient
            direction
            transferInfo {
              ... on NativeTransferInfo {
                transferType
                value
              }
              ... on FTTransferInfo {
                transferType
                tokenAddress
                tokenName
                tokenSymbol
                logoUri
                decimals
                value
              }
              ... on NFTTransferInfo {
                transferType
                tokenAddress
                tokenName
                tokenSymbol
                logoUri
                tokenId
              }
            }
          }
          ... on Creation {
            transactionType
            creator
          }
          ... on Cancellation {
            transactionType
            isCancellation
          }
        }
      }
      details {
        from
        to
        value
        dataHex
        hash
        executedAt
        fee
      }
    }
  }
`;
exports.GET_TX_QUEUE = (0, client_1.gql) `
  query transactionQueue($chainId: String!, $safeAddress: String!) {
    transactionQueue(chainId: $chainId, safeAddress: $safeAddress) {
      details {
        from
        to
        value
        dataHex
        hash
        executedAt
        fee
      }
      summary {
        createdAt
        status
        transactionInfo {
          ... on Transfer {
            transactionType
            sender
            recipient
            direction
            transferInfo {
              ... on NativeTransferInfo {
                transferType
                value
              }
              ... on FTTransferInfo {
                transferType
                tokenAddress
                tokenName
                tokenSymbol
                logoUri
                decimals
                value
              }
              ... on NFTTransferInfo {
                transferType
                tokenAddress
                tokenName
                tokenSymbol
                logoUri
                tokenId
              }
            }
          }
          ... on Creation {
            transactionType
            creator
          }
          ... on Cancellation {
            transactionType
            isCancellation
          }
        }
        multiSigExecutionInfo {
          orderCellBoc
          queryId
          expiredAt
          confirmationsRequired
          confirmationsSubmitted
          confirmations
          executor
        }
      }
    }
  }
`;
exports.CREATE_TX = (0, client_1.gql) `
  mutation CreateTransfer($content: createTransferReq!) {
    createTransfer(content: $content) {
      success
      error {
        code
        detail
        extra
      }
    }
  }
`;
exports.SIGN_TX = (0, client_1.gql) `
  mutation signTransaction($content: signTransactionReq!) {
    signTransaction(content: $content) {
      success
      error {
        code
        detail
        extra
      }
    }
  }
`;
exports.GET_BALANCE = (0, client_1.gql) `
  query Balance($chainId: String!, $safeAddress: String!) {
    balance(chainId: $chainId, safeAddress: $safeAddress) {
      fiatTotal
      assets {
        tokenInfo {
          jettonMinterAddress
          tokenName
          tokenSymbol
          logoUri
          decimals
        }
        jettonWalletAddress
        balance
        fiatBalance
        fiatConversion
      }
    }
  }
`;
